import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { AccountService } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { WebviewService } from 'src/app/services/platform/webview.service';

@Component({
  standalone: true,
  selector: 'app-account-sign-in-step',
  templateUrl: './sign-in-step.component.html',
  styleUrls: ['./sign-in-step.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatCheckbox, ModalOptionPanelComponent]
})
export class SignInStepComponent {
  @Input() formGroup: FormGroup | null = null;
  @Input() firstStepError: string = '';
  @Input() preiOS13WebView: boolean = false;
  @Input() androidWebView: boolean = false;

  @Output() signIn = new EventEmitter<void>();
  @Output() register = new EventEmitter<void>();
  @Output() forgotPassword = new EventEmitter<void>();

  showPassword = false;

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  constructor(
    public accountService: AccountService,
    public languageService: LanguageService,
    public settingsService: SettingsService,
    public webviewService: WebviewService
  ) {
    // This step shows the Google and Apple buttons, so their SDKs are needed now (not on every page).
    this.accountService.prepareSocialSignIn();
  }
}
